var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("generic-modal", {
        ref: "lifeInsuranceModal",
        attrs: {
          id: "life-insurance-modal",
          "modal-dialog-scrollable": false,
          "modal-dialog-size": "lg",
          "footer-close-button-text": _vm.$t("global.words.cancel"),
        },
        on: { show: _vm.handleShow, hide: _vm.handleHidden },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("application-form.personalInsuranceProvider")
                      ) +
                      "\n      "
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("div", { staticClass: "row justify-content-around" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm col-md-4 form-container" },
                    [
                      _c(
                        "h6",
                        { staticClass: "form-title font-sm mb-0" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("application-form.provider"))
                          ),
                          _c("input-required-indicator"),
                          _vm._v(" "),
                          _vm.loadingProviders
                            ? _c("inline-loader", {
                                staticClass: "mx-2",
                                attrs: { width: "12px", height: "12px" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "material-input",
                        {
                          attrs: { "no-label": "" },
                          model: {
                            value: _vm.providerDropdownValue,
                            callback: function ($$v) {
                              _vm.providerDropdownValue = $$v
                            },
                            expression: "providerDropdownValue",
                          },
                        },
                        [
                          _c("v-select-field", {
                            staticClass: "simple-dd",
                            attrs: {
                              options: _vm.providerNameOptions,
                              "default-value": _vm.providerDropdownValue,
                              clearable: false,
                              placeholder: _vm.$t("application-form.provider"),
                            },
                            on: { "option:selected": _vm.selectProviderName },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm col-md-4 form-container" },
                    [
                      _c(
                        "h6",
                        { staticClass: "form-title font-sm mb-0" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("response-information.product"))
                          ),
                          _c("input-required-indicator"),
                          _vm._v(" "),
                          _vm.loadingProviders
                            ? _c("inline-loader", {
                                staticClass: "mx-2",
                                attrs: { width: "12px", height: "12px" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "material-input",
                        {
                          attrs: { "no-label": "" },
                          model: {
                            value: _vm.productDropdownValue,
                            callback: function ($$v) {
                              _vm.productDropdownValue = $$v
                            },
                            expression: "productDropdownValue",
                          },
                        },
                        [
                          _c("v-select-field", {
                            key:
                              "product-select-" +
                              (_vm.productNameOptions.length || 0) +
                              "-" +
                              (_vm.productDropdownValue || ""),
                            staticClass: "simple-dd",
                            attrs: {
                              id: "productNameDropdown",
                              options: _vm.productNameOptions,
                              "default-value": _vm.productDropdownValue,
                              label: "productName",
                              clearable: false,
                              placeholder: _vm.$t(
                                "response-information.product"
                              ),
                            },
                            on: { "option:selected": _vm.selectProductName },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex flex-row justify-content-center my-3",
                  },
                  [
                    _c("div", { staticClass: "logo" }, [
                      _vm.providerDropdownValue
                        ? _c("img", {
                            staticClass: "logo-img",
                            attrs: {
                              src: require("@Shared/@Assets/img/insurance-product-logo/" +
                                _vm.providerDropdownValue +
                                ".png"),
                              alt: "insurance-product-logo",
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex flex-row justify-content-center my-3",
                  },
                  [
                    _c("span", { staticClass: "bold" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("application-form.applicantsToBeInsured")
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-row justify-content-center ml-3 mb-3",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      _vm._l(_vm.allApplicants, function (applicant, index) {
                        return _c("div", { key: applicant.username }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pretty p-icon p-jelly p-smooth p-curve mr-2",
                            },
                            [
                              _c("input", {
                                staticClass: "checkbox",
                                attrs: {
                                  id: "applicant-" + index,
                                  disabled: index === 0,
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked:
                                    index === 0
                                      ? true
                                      : _vm.applicantsChecked[index].isChecked,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.applicantsChecked[index].isChecked =
                                      !_vm.applicantsChecked[index].isChecked
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "state p-success",
                                  style: { opacity: 1 },
                                },
                                [
                                  _c("icon", {
                                    staticClass: "icon",
                                    attrs: { name: "check" },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { attrs: { for: "applicant-" + index } },
                                    [_vm._v(_vm._s(applicant.fullName))]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      _vm._l(_vm.allApplicants, function (applicant) {
                        return _c("div", { key: applicant.username }, [
                          _c("span", [_vm._v(_vm._s(applicant.applicantType))]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _c("p", { staticClass: "mb-2" }, [
                    _vm._v(_vm._s(_vm.$t("application-form.insuranceNote"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "pretty p-icon p-jelly p-smooth p-curve mr-2",
                    },
                    [
                      _c("input", {
                        staticClass: "checkbox",
                        attrs: { id: "applicant-", type: "checkbox" },
                        domProps: { checked: _vm.consentChecked },
                        on: {
                          click: function ($event) {
                            _vm.consentChecked = !_vm.consentChecked
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "state p-success" },
                        [
                          _c("icon", {
                            staticClass: "icon",
                            attrs: { name: "check" },
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "applicant" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("application-form.insuranceConsent")
                                ) +
                                "\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c("simple-button", {
                  attrs: {
                    "class-name": "btn-sm mr-2 btn-primary",
                    type: "white",
                    disabled:
                      !_vm.consentChecked ||
                      _vm.productDropdownValue === "" ||
                      _vm.providerDropdownValue === "",
                    loading: _vm.sendingSubmitRequest,
                    text: _vm.$t("application-form.submitRequest"),
                  },
                  on: { click: _vm.handleSubmitRequest },
                }),
                _vm._v(" "),
                _vm.errorMsg.length
                  ? _c("div", { staticClass: "w-100 mt-2 d-flex" }, [
                      _c("div", { staticClass: "d-flex flex-column mt-3" }, [
                        _c(
                          "div",
                          { staticClass: "text-danger font-weight-bold h5" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("application-form.submitRequestError")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "mb-0 text-dark pl-0" },
                          _vm._l(_vm.errorMsg, function (error, index) {
                            return _c("li", { key: index }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(error) +
                                  "\n            "
                              ),
                            ])
                          }),
                          0
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }